import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const sectionHeadingVariants = cva("", {
  variants: {
    variant: {
      question: "text-2xl sm:text-3xl lg:text-4xl font-bold text-[#B87333]",
      headline:
        "text-3xl sm:text-4xl lg:text-6xl font-black text-slate-900 leading-tight",
      subheadline:
        "text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 leading-tight",
    },
  },
  defaultVariants: {
    variant: "headline",
  },
});

const defaultElements: Record<string, React.ElementType> = {
  question: "p",
  headline: "h2",
  subheadline: "h3",
};

export interface SectionHeadingProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof sectionHeadingVariants> {
  as?: React.ElementType;
}

const SectionHeading = React.forwardRef<HTMLElement, SectionHeadingProps>(
  ({ className, variant, as, children, ...props }, ref) => {
    const Comp = as ?? defaultElements[variant ?? "headline"] ?? "h2";
    return (
      <Comp
        className={cn(sectionHeadingVariants({ variant, className }))}
        ref={ref}
        {...props}
      >
        {children}
      </Comp>
    );
  },
);
SectionHeading.displayName = "SectionHeading";

function Muted({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return <span className={cn("text-slate-600", className)} {...props} />;
}

export { SectionHeading, Muted, sectionHeadingVariants };
